import React from 'react';
import PropTypes from 'prop-types';
import ProductButton from '../../../../products/components/product_button/ProductButton';
import { numberToCurrency } from '../../../../checkout/services/utils';
import Rating from '../../../../products/components/rating/Rating';
import QuadpayWidget from '../../../../cart/components/quadpay_widget/QuadpayWidget';
import styles from './ProductInfo.module.sass';
import Select from '../../../../ui_kit/select/Select';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import ProofTester from '../proof_tester/ProofTester';
import scrollToElement from '../../../../services/smooth_scroll';
import DeliveryFrequency from './delivery_frequency/DeliveryFrequency';
import Share from './share/Share';
import JoinWaitlist from '../../../../campaign/components/join_waitlist/JoinWaitlist';
import Variants from '../../../../campaign/components/campaign_info/variants/Variants';
import UpvoteAndComments from '../../../../campaign/components/upvote_and_comments/UpvoteAndComments';
import Preorder from '../../../../campaign/components/preorder/Preorder';
import CampaignHints from './campaign_hints/CampaignHints';
import PointsInformation from './points_information/PointsInformation';

const scrollToReviews = () => scrollToElement('react-reviews');

class ProductInfo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedVariant: props.product.variants.find((variant) => variant.id === props.variant.id),
    };
  }

  onVariantSelect = (event) => {
    const { product: { variants } } = this.props;

    const selectedVariant = variants.find((variant) => variant.id === Number(event.target.value));

    this.setState({ selectedVariant });

    document.body.style.cursor = 'wait';
    if (window.location.pathname.includes('products')) {
      window.location.href = `/shop/products/${selectedVariant.slug}/`;
    } else {
      window.location.href = `/campaigns/${selectedVariant.slug}/`;
    }
  };

  subscribe = (params) => {
    const { productSubscribe } = this.props;
    productSubscribe(params);
  };

  render() {
    const {
      product, products, variant, addToBagClickHandler,
      selectedDeliveryFrequency, setSelectedDeliveryFrequency, subscriptionDiscountPercentage,
      campaign, selectVariant,
    } = this.props;
    const {
      id, available, shortDescription, url,
      redirectionEnabled, redirectText, limitation, rating, reviewsCount,
      variants, redirectLink, hasProofTester, image,
    } = product;
    let { sku } = product;
    const productVariantText = product.variant;

    const {
      discount, price, waitlistSubscribable, subscribable, estimatedShipDate,
    } = variant;

    const description = (
      variant.description && variant.description.length > 0
    ) ? variant.description : product.description;

    const name = (
      variant.name && variant.name.length > 0 ? variant.name : product.name
    );
    const foundProduct = products.find((object) => object.id === id);
    const loading = foundProduct && foundProduct.loading;
    const subscribed = foundProduct && foundProduct.subscribed;
    const { selectedVariant } = this.state;
    if (variants.length > 0) {
      ({ sku } = selectedVariant);
    }

    return (
      <div className={styles['product-info']}>
        <div className={`${styles.content} ${campaign ? styles.campaign : ''}`}>
          { !campaign && (
            <>
              <h1 className={styles.title}>
                {name}
              </h1>
              <div className={styles['price-and-rating']}>
                { rating > 0 && (
                  <div className={styles.rating} href="#react-reviews">
                    <div className={styles['rating-value']}>{rating}</div>
                    <Rating rating={rating} />
                    <ClickableDiv className={styles.reviews} onClick={scrollToReviews}>
                      {`${reviewsCount.toLocaleString('en-US')} Reviews`}
                    </ClickableDiv>
                  </div>
                )}
                <div className={styles['price-wrapper']}>
                  <div className={styles.price}>
                    { discount > 0 && (
                    <div className={styles['full-price']}>
                      {numberToCurrency(price)}
                    </div>
                    )}
                    <div className={styles.total}>
                      {numberToCurrency(parseFloat(price) - parseFloat(discount))}
                    </div>
                  </div>
                </div>
              </div>
              <QuadpayWidget
                orderTotal={parseFloat(price) - parseFloat(discount)}
                className={styles['quadpay-widget']}
              />
              <div className={styles['short-description']}>{shortDescription}</div>
              { productVariantText && (
                <div className={styles.variant}>
                  {productVariantText}
                </div>
              )}
              { variants.length > 0 && (
                !campaign || (campaign && !campaign.available_for_preorder)
              ) && (
                <Select
                  value={selectedVariant.id}
                  options={variants.map((object) => (
                    { value: object.id, label: object.option_value.presentation }
                  ))}
                  onChange={this.onVariantSelect}
                  className={styles.select}
                />
              )}
              { estimatedShipDate && (
                <div className={styles['estimated-ship-date']}>
                  {`Estimated Ship Date: ${estimatedShipDate}`}
                </div>
              )}
              { !waitlistSubscribable && subscribable && (
                <DeliveryFrequency
                  selectedDeliveryFrequency={selectedDeliveryFrequency}
                  setSelectedDeliveryFrequency={setSelectedDeliveryFrequency}
                  subscriptionDiscountPercentage={subscriptionDiscountPercentage}
                />
              )}
              <div className={styles['product-button-wrapper']}>
                <ProductButton
                  waitlistSubscribable={waitlistSubscribable}
                  available={available}
                  showAddToBag
                  showSubscription
                  redirectionEnabled={redirectionEnabled}
                  redirectText={redirectText}
                  redirectLink={redirectLink}
                  limitation={limitation}
                  productId={id}
                  subscribed={subscribed}
                  subscribe={this.subscribe}
                  price={parseFloat(price)}
                  discount={parseFloat(discount)}
                  estimatedShipDate={estimatedShipDate}
                  loading={loading}
                  sku={sku}
                  name={name}
                  variant={productVariantText}
                  addToBagClickHandler={addToBagClickHandler}
                  image={image}
                  productUrl={url}
                />
              </div>
              { description && (
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
              {hasProofTester && (<ProofTester />)}
            </>
          )}
          { campaign && (
            <>
              { !campaign.available_for_preorder && (
                <UpvoteAndComments className={styles.comments} campaign={campaign} />
              )}
              <div className={styles['price-and-rating']}>
                <div className={styles['price-wrapper']}>
                  <div className={styles.price}>
                    { discount > 0 && (
                    <div className={styles['full-price']}>
                      {numberToCurrency(price)}
                    </div>
                    )}
                    <div className={styles.total}>
                      {numberToCurrency(parseFloat(price) - parseFloat(discount))}
                    </div>
                  </div>
                </div>
              </div>
              <h1 className={styles.title}>
                {name}
              </h1>
              <PointsInformation
                price={campaign.available_for_preorder ? 100 : 50}
                className={styles.points}
                waitlist={!campaign.available_for_preorder}
              />
              <div className={styles['short-description']}>{shortDescription}</div>
              { productVariantText && (
                <div className={styles.variant}>
                  {productVariantText}
                </div>
              )}
              { variants.length > 0 && (
                <Select
                  value={selectedVariant.id}
                  options={variants.map((object) => (
                    { value: object.id, label: object.option_value.presentation }
                  ))}
                  onChange={this.onVariantSelect}
                  className={styles.select}
                />
              )}
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: description }}
              />
              { campaign.variants.length > 0 && !campaign.is_voted && !campaign.is_winner && (
                <div className={styles['select-wrapper']}>
                  <Variants
                    variants={campaign.variants}
                    selectVariant={selectVariant}
                    selectedVariantId={campaign.selectedVariantId}
                    variantsSelectText={campaign.variants_select_text}
                  />
                </div>
              )}
              { estimatedShipDate && (
                <div className={styles['estimated-ship-date']}>
                  {`Estimated Ship Date: ${estimatedShipDate}`}
                </div>
              )}
              <div className={styles['join-waitlist']}>
                { campaign.available_for_preorder && (
                  <Preorder
                    text={campaign.preorders_percent === 100 ? 'PRE-ORDER AVAILABLE' : 'PRE-ORDER'}
                    productId={id}
                    price={parseFloat(price)}
                    discount={parseFloat(discount)}
                    loading={loading}
                    sku={sku}
                    name={name}
                    variant={productVariantText}
                    addToBagClickHandler={addToBagClickHandler}
                    image={image}
                    productUrl={url}
                  />
                )}
                { !campaign.available_for_preorder && (
                  <JoinWaitlist campaignId={campaign.id} disableButton />
                )}
                <CampaignHints
                  availableForPreorder={campaign.available_for_preorder}
                  estimatedShipDate={estimatedShipDate}
                  productId={id}
                  subscribe={this.subscribe}
                  subscribed={subscribed}
                  loading={loading}
                />
              </div>
              { !campaign.available_for_preorder && <Share /> }
            </>
          )}
        </div>
      </div>
    );
  }
}

ProductInfo.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    rating: PropTypes.number,
    image: PropTypes.string,
    subtitle: PropTypes.string,
    url: PropTypes.string.isRequired,
    reviewsCount: PropTypes.number,
    subscribed: PropTypes.bool,
    available: PropTypes.bool,
    redirectionEnabled: PropTypes.bool,
    redirectText: PropTypes.string,
    redirectLink: PropTypes.string,
    limitation: PropTypes.number,
    showAddToBag: PropTypes.bool,
    loading: PropTypes.bool,
    shortDescription: PropTypes.string,
    previewText: PropTypes.string,
    variant: PropTypes.string,
    variants: PropTypes.arrayOf(PropTypes.shape({})),
    description: PropTypes.string,
    hasProofTester: PropTypes.bool,
    sku: PropTypes.string,
  }).isRequired,
  variant: PropTypes.shape({
    id: PropTypes.number,
    price: PropTypes.string,
    discount: PropTypes.string,
    description: PropTypes.string,
    waitlistSubscribable: PropTypes.bool,
    subscribable: PropTypes.bool,
    estimatedShipDate: PropTypes.string,
  }).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  addToBagClickHandler: PropTypes.func.isRequired,
  productSubscribe: PropTypes.func.isRequired,
  selectedDeliveryFrequency: PropTypes.number.isRequired,
  setSelectedDeliveryFrequency: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
  subscriptionDiscountPercentage: PropTypes.number.isRequired,
  campaign: PropTypes.shape({
    votes_percent: PropTypes.number,
    preorders_percent: PropTypes.number,
    id: PropTypes.number,
    is_voted: PropTypes.bool,
    is_winner: PropTypes.bool,
    selectedVariantId: PropTypes.number,
    variants_select_text: PropTypes.string,
    variants: PropTypes.arrayOf(PropTypes.shape({})),
    upvotes_total: PropTypes.number,
    is_upvoted: PropTypes.bool,
    is_downvoted: PropTypes.bool,
    available_for_preorder: PropTypes.bool,
    slug: PropTypes.string,
  }),
  selectVariant: PropTypes.func.isRequired,
};

export default ProductInfo;
